import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ModalService } from "@core-services/modal.service";
import { UserService } from "@main-services/user.service";
import { Observable } from "rxjs";
import { skip } from "rxjs/operators";
import { UserVerificationState } from "@models";
import { BrowserTab } from "@modules/core/util/browser-tab";
import { DepositsBannerFacade } from "./deposits-banner.facade";
import { FiatDepositEntryService } from "@modules/+new/payments/features/fiat-deposit/infrastructure/fiat-deposit-entry.service";

@UntilDestroy()
@Component({
	selector: "deposits-banner",
	templateUrl: "./deposits-banner.component.html",
	styleUrls: ["../../../../theme/shared/banner-card.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DepositsBannerFacade],
	standalone: false
})
export class DepositsBannerComponent {
	public readonly shouldShowDepositsBanner$: Observable<boolean> =
		this.depositsBannerFacade.getDepositsBannerVisibility$();

	public constructor(
		private readonly modalService: ModalService,
		private readonly userService: UserService,
		private readonly depositsBannerFacade: DepositsBannerFacade,
		private readonly fiatDepositEntryService: FiatDepositEntryService
	) {
		this.userService.verificationState$.pipe(skip(1), untilDestroyed(this)).subscribe((state) => {
			if (state === UserVerificationState.VERIFIED) {
				BrowserTab.reload();
			}
		});
	}

	public deposit(): void {
		this.fiatDepositEntryService.openDeposit();
	}
}
